// V1-INTERACTIONS §4.1 — Today's section chips. The wire keys (`#today?filter=<key>`, `today.queue.section`) never
// change; only the words and the tone do, so a tile route, a deep link and a saved filter all keep working.
export const SECTIONS = ["all", "needs_you", "overdue", "waiting", "upcoming", "recent"] as const;
export type SectionKey = (typeof SECTIONS)[number];

// EM-21/EM-22: "Needs you" reads as Attention Required and "Waiting" as Pending Others, for every seat — Today is one
// component for all five roles and §1.3 keeps role tables out of the view layer.
export const SECTION_LABEL: Record<SectionKey, string> = {
  all: "All",
  needs_you: "Attention Required",
  overdue: "Overdue",
  waiting: "Pending Others",
  upcoming: "Upcoming",
  recent: "Recent",
};

// EM-22's palette: All white · Attention Required orange · Overdue red · Pending Others yellow · Upcoming grey;
// Recent (completed work) shares the settled grey. The tone is a Today-only modifier because `.chip` itself is shared
// with the sign-in seat chips and the applied-filter row — measured inks live in styles/tokens.css (§6.3).
export const SECTION_TONE: Record<SectionKey, string> = {
  all: "chip--tone-all",
  needs_you: "chip--tone-attention",
  overdue: "chip--tone-overdue",
  waiting: "chip--tone-pending",
  upcoming: "chip--tone-upcoming",
  recent: "chip--tone-recent",
};

/** The chip key a `#today?filter=…` route asks for, or All when the route names nothing this screen has. */
export const sectionFromHash = (hash: string): SectionKey => {
  const value = new URLSearchParams(hash.split("?")[1]).get("filter");
  return SECTIONS.find(section => section === value) ?? "all";
};
